import {
    call, takeEvery, select, put,
} from 'redux-saga/effects';
import { getBoard } from '../../Common/api';
import { setActiveBoard } from '../RightColumn/RightMenu/rightMenuSlice';
import { saveInLocalStorage } from './localStorage';
import { actions as commandsActions } from './Mat/Commands/commandsSlice';
import { MAT_NAME, MAT_COORDS_NAME } from './matConfigs';
import { actions as matCoordsActions } from './matCoordsSlice';

function* createBoardsSaga({ selectors, actions, boardName }) {
    function* saveBoardInLocalStorageHandler() {
        const board = yield select(selectors.selectBoard);
        yield call(saveInLocalStorage, board, boardName);
    }

    function* fetchBoardHandler({ payload: hash }) {
        const board = yield call(getBoard, hash);

        if (board.type === MAT_NAME) {
            yield put(setActiveBoard(board.type));
            yield put(actions.setBoardState(JSON.parse(board.data)));
            yield put(commandsActions.setBoardState(JSON.parse(board.commands)));
        } else if (board.type === MAT_COORDS_NAME) {
            yield put(setActiveBoard(board.type));
            yield put(matCoordsActions.setBoardState(JSON.parse(board.data)));
        } else {
            yield put(setActiveBoard(MAT_NAME));
        }
    }

    yield takeEvery('*', saveBoardInLocalStorageHandler);
    yield takeEvery(actions.fetchBoard.type, fetchBoardHandler);
}

export default createBoardsSaga;
